import type { FC, ElementType } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@material-ui/core';
import { ChevronRight as ChevronRightIcon } from '../icons/chevron-right';
import { ChevronDown as ChevronDownIcon } from '../icons/chevron-down';
import { ExternalLink as ExternalLinkIcon } from '../icons/external-link';

interface DashboardSidebarItemProps {
  active: boolean;
  activeHref: string;
  external?: boolean;
  href?: string;
  icon: ElementType;
  items?: Array<{ href: string; title: string; }>
  onClose: () => void;
  onOpenItem: () => void;
  open: boolean;
  title: string;
}

export const DashboardNavbarMenuItem: FC<DashboardSidebarItemProps> = (props) => {
  const {
    active,
    external,
    href,
    icon: Icon,
    items,
    onClose,
    open,
    title
  } = props;
  const { t } = useTranslation();

  // Branch currently this piece of code does nothing.
  if (items) {
    return (
      <List
        disablePadding
        sx={{ width: '100%' }}
      >
        <ListItemButton
          divider
          key={title}
          onClick={onClose}
          component={RouterLink}
          to={href}
          sx={{
            alignItems: 'center',
            borderColor: 'neutral.100',
            display: 'flex',
            px: 3,
            py: 1.5,
            ...active && ({
              backgroundColor: 'neutral.100',
              color: '#ffffff'
            }),
            '&:hover': {
              backgroundColor: 'neutral.100',
              color: '#ffffff'
            }
          }}
        >
          <ListItemIcon
            sx={{
              color: 'inherit',
              minWidth: 0,
              mr: 1
            }}
          >
            <Icon />
          </ListItemIcon>
          <ListItemText
            primary={t(title)}
            primaryTypographyProps={{
              color: 'inherit',
              variant: 'caption'
            }}
          />
          {
            open
              ? (
                <ChevronDownIcon
                  fontSize="small"
                  sx={{ color: '#506176' }}
                />
              )
              : (
                <ChevronRightIcon
                  fontSize="small"
                  sx={{ color: '#506176' }}
                />
              )
          }
        </ListItemButton>
        <Collapse
          in={open}
          unmountOnExit
        >
          <List
            disablePadding
            sx={{ width: '100%' }}
          >
            {items.map((item) => {
              const key = item.href;
              return (
                <ListItemButton
                  component={RouterLink}
                  divider
                  key={key}
                  onClick={onClose}
                  sx={{
                    alignItems: 'center',
                    borderColor: 'neutral.100',
                    display: 'flex',
                    px: 3,
                    py: 1.5,
                    '&:hover': {
                      backgroundColor: 'neutral.100',
                      color: '#ffffff'
                    }
                  }}
                  to={item.href}
                >
                  <ListItemText
                    primary={t(item.title)}
                    primaryTypographyProps={{
                      color: 'inherit',
                      variant: 'caption'
                    }}
                    sx={{ my: 0 }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>
      </List>
    );
  }

  // Leaf
  console.log(active);
  return (
    <>
      <ListItemButton
        component={RouterLink}
        divider
        onClick={onClose}
        sx={{
          alignItems: 'center',
          borderColor: 'neutral.600',
          display: 'flex',
          px: 3,
          py: 1.5,
          '&:hover': {
            backgroundColor: 'neutral.600',
            color: '#ffffff'
          }
        }}
        target={external ? '_target' : '_self'}
        to={href}
      >
        <ListItemIcon
          sx={{
            color: active ? 'primary.main' : 'white',
            minWidth: 0,
            mr: 1
          }}
        >
          <Icon />
        </ListItemIcon>
        <ListItemText
          primary={t(title)}
          primaryTypographyProps={{
            color: active ? 'primary.main' : 'white',
            variant: 'subtitle2'
          }}
        />
        {external && <ExternalLinkIcon sx={{ color: 'neutral.100' }} />}
      </ListItemButton>
    </>
  );
};

DashboardNavbarMenuItem.propTypes = {
  active: PropTypes.bool,
  external: PropTypes.bool,
  href: PropTypes.string,
  // @ts-ignore
  icon: PropTypes.elementType,
  items: PropTypes.array,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string
};
